import useAxiosService from './useAxiosService'

const useAddressService = () => {
  const { get } = useAxiosService()
  const getListProvince = async () => {
    const res = await get('addresses/provinces')
    return res
  }

  const getProvinceById = async (provinceId: number, params: any) => {
    const res = await get(`addresses/provinces/${provinceId}`, params)
    return res
  }

  const getDistrictByProvince = async (id: number) => {
    const res = await get(`addresses/provinces/${id}/districts`)
    const data = res
    return data
  }

  const getWardByDistrict = async (provinceId: number, districtId: number) => {
    const res = await get(
      `addresses/provinces/${provinceId}/districts/${districtId}/wards`
    )
    const data = res
    return data
  }
  return {
    getListProvince,
    getProvinceById,
    getDistrictByProvince,
    getWardByDistrict
  }
}

export default useAddressService
